import React, { useState } from 'react';
import css from './SectionDescriptionClamp.module.css';

const SectionDescriptionClamp = ({ text }) => {
  const [expanded, setExpanded] = useState(false);

  if (!text) return null;

  return (
    <div className={css.root}>
      <p className={expanded ? css.textExpanded : css.textClamped}>{text}</p>
      <button
        type="button"
        className={css.toggleButton}
        onClick={() => setExpanded(prev => !prev)}
      >
        {expanded ? 'Show less' : 'Read more'}
      </button>
    </div>
  );
};

export default SectionDescriptionClamp;
